export default __webpack_public_path__ + "static/media/subtitle.27405252.png";